export interface OidcSskCompletionData {
  code: string;
  digestHex: string;
  supportEmail: string;
}

// Reads the backend's #oidc-ssk-data element (one-time code + padded digest); null if absent.
export function extractOidcSskData(
  htmlContent: string
): OidcSskCompletionData | null {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const dataElement = doc.getElementById('oidc-ssk-data');

  if (!dataElement?.dataset.code || !dataElement.dataset.digest) {
    return null;
  }

  return {
    code: dataElement.dataset.code,
    digestHex: dataElement.dataset.digest,
    supportEmail: dataElement.dataset.supportEmail ?? '',
  };
}
